import { type Address, zeroAddress } from 'viem'
import { arbitrum, avalanche, base, bsc, mainnet, optimism, polygon } from 'viem/chains'
import { ChainId } from '../interfaces'

export const HOMECHAIN_CALLBACK_BUILDER: Record<ChainId, Address> = {
  [arbitrum.id]: '0xc9a729C60fdBB1117E75D86632b0157d9680D3A0',
  [avalanche.id]: zeroAddress,
  [mainnet.id]: zeroAddress,
  [optimism.id]: zeroAddress,
  [polygon.id]: zeroAddress,
  [bsc.id]: zeroAddress,
  [base.id]: '0xa79375406D9156Dd205997D2A203eC12D8eD0ACd',
}

export const REMOTE_CALLBACK_BUILDER: Record<ChainId, Address> = {
  [arbitrum.id]: zeroAddress,
  [avalanche.id]: '0x71c2066FFf245C5cBE4491A25c9F66063693Ec92',
  [mainnet.id]: zeroAddress,
  [optimism.id]: '0xBBfCb07041A11cA8da1DB03Cd6e671bE3Fd0caB1',
  [bsc.id]: '0x1eE1bF4584742a8726bfF46c800f47dBdE3D7BC0',
  [base.id]: zeroAddress,
  [polygon.id]: '0x16FC69eDEfdEc2919fF12810dE96dc6A7ec9d37B',
}
